import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../actions";

const initialState = {
  page: 0,
  data: {
    orderForm: 31,
    orderNumber: '',
  },
  billingInformation: {
    firstName: "",
    lastName: "",
    company: "",
    phone: "",
    email: "",
    shippingOption: "",
    dropboxLocation: "",
    dropoffDate: "",
    billingMethod: "",
    purchasingAgentName: "",
    purchasingAgentEmail: "",
    poNumber: "",
    grantNumber:"",
    grantPi:"",
    grantNote:"",
    ccNumber: "",
    ccMonth: "",
    ccYear: "",
    cvv: "",
    cardType: "",
    ccName: "",
    acgtCard: "",
  },
  contract: {
    quoteNumber: "",
    description: "",
    comments: "",
  },
};

const contractFormSlice = createSlice({
  name: "contractorderform",
  initialState,
  reducers: {
    //action creators
    resetContractState(state, action) {
      Object.assign(state, initialState);
      return;
    },
    contractPrevStep: (state, action) => {
      state.page = state.page - 1;
    },
    contractNextStep: (state, action) => {
      state.page = state.page + 1;
    },
    contractSetStep: (state, action) => {
      state.page = action.payload;
    },
    resetContractPage: (state, action) => {
      state.page = action.payload;
    },
    setContractQuoteNumber: (state, action) => {
      state.contract.quoteNumber = action.payload;
    },
    setContractDescription: (state, action) => {
      state.contract.description = action.payload;
    },
    setContractComments: (state, action) => {
      state.contract.comments = action.payload;
    },
    setContractDropboxLocation(state, action) {
      state.billingInformation.dropboxLocation = action.payload.label;
      return;
    },
    setContractDropoffDate(state, action) {
      state.billingInformation.dropoffDate = action.payload;
      return;
    },
    setContractFirstName(state, action) {
      state.billingInformation.firstName = action.payload;
      return;
    },
    setContractLastName(state, action) {
      state.billingInformation.lastName = action.payload;
      return;
    },
    setContractCompany(state, action) {
      state.billingInformation.company = action.payload;
    },
    setContractPhone(state, action) {
      const phoneRegex = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
      const result = action.payload;
      state.billingInformation.phone = result;
    },
    setContractEmail(state, action) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      state.billingInformation.email = action.payload;
    },
    setContractShippingOption(state, action) {
      state.billingInformation.shippingOption = action.payload;
      return;
    },
    setContractAcgtCard(state, action) {
      state.billingInformation.acgtCard = action.payload;
      return;
    },
    setContractCCNumber(state, action) {
      state.billingInformation.ccNumber = action.payload;
      return;
    },
    setContractCCMonth(state, action) {
      state.billingInformation.ccMonth = action.payload;
      return;
    },
    setContractCCYear(state, action) {
      state.billingInformation.ccYear = action.payload;
      return;
    },
    setContractCVV(state, action) {
      state.billingInformation.cvv = action.payload;
      return;
    },
    setContractCCName(state, action) {
      state.billingInformation.ccName = action.payload;
      return;
    },
    setContractCardType(state, action) {
      state.billingInformation.cardType = action.payload;
      return;
    },
    setContractBillingMethod(state, action) {
      state.billingInformation.billingMethod = action.payload;
      return;
    },
    setContractPurchasingAgentName(state, action) {
      state.billingInformation.purchasingAgentName = action.payload;
      return;
    },
    setContractPurchasingAgentEmail(state, action) {
      state.billingInformation.purchasingAgentEmail = action.payload;
      return;
    },
    setContractPoNumber(state, action) {
      state.billingInformation.poNumber = action.payload;
      return;
    },
    setContractOrderNumber(state, action) {
      state.data.orderNumber = action.payload;
      return;
    },
    setContractGrantNumber(state, action) {
      state.billingInformation.grantNumber = action.payload;
      return;
    },
    setContractGrantPI(state, action) {
      state.billingInformation.grantPi = action.payload;
      return;
    },
    setContractGrantNote(state, action) {
      state.billingInformation.grantNote = action.payload;
      return;
    },
  },
  //tell our combined reducer to look for additional action types
  extraReducers(builder) {
    builder.addCase(reset, (state, action) => {
      return {};
    });
  },
});

export const {
  resetContractState,
  contractNextStep,
  contractPrevStep,
  contractSetStep,
  resetContractPage,
  setContractQuoteNumber,
  setContractDescription,
  setContractComments,
  setContractDropoffDate,
  setContractDropboxLocation,
  setContractFirstName,
  setContractLastName,
  setContractCompany,
  setContractPhone,
  setContractEmail,
  setContractShippingOption,
  setContractAcgtCard,
  setContractCCNumber,
  setContractCCMonth,
  setContractCCYear,
  setContractCVV,
  setContractCCName,
  setContractCardType,
  setContractPurchasingAgentName,
  setContractPurchasingAgentEmail,
  setContractPoNumber,
  setContractOrderNumber,
  setContractGrantNote,
  setContractGrantNumber,
  setContractGrantPI,
  setContractBillingMethod,
} = contractFormSlice.actions;
export const contractFormReducer = contractFormSlice.reducer;
